var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "yt-video" } },
    [
      _vm.ytvideo
        ? [
            _c("div", { attrs: { id: "yt-modal" } }, [
              _c(
                "div",
                {
                  staticClass: "modal fade yt-modal",
                  attrs: { id: "yt-single", tabindex: "-1", role: "dialog" }
                },
                [
                  _c("div", { staticClass: "modal-dialog" }, [
                    _c("div", { staticClass: "modal-content" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("div", { staticClass: "modal-body" }, [
                        _c("iframe", {
                          attrs: {
                            width: "100%",
                            height: "315",
                            src:
                              "https://www.youtube-nocookie.com/embed/" +
                              _vm.ytvideo,
                            title: "YouTube video player",
                            frameborder: "0",
                            allow:
                              "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                            allowfullscreen: ""
                          }
                        })
                      ])
                    ])
                  ])
                ]
              )
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("div", { staticClass: "modal-title h3" }, [_vm._v("Youtube")]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-hidden": "true"
          }
        },
        [_vm._v("×")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }